var MultiSelect = Class.create(TextboxList, {
	tagList: {},

	loptions: $H({
		autocomplete: {
			'opacity': 0.9,
			'maxresults': 10,
			'minchars': 1
		}
	}),

	initialize: function($super, element, autoholder, options, func) {
		element = $(element);
		var kids = $(element).up('.multi_select').children;
		if(kids && kids[0].hasClassName('holder'))
			kids[0].remove();
			//return tagsMultiSelect;	/* Does this have a local name?
		$super(element, options);

		// Add the taggableType as a data attribute
		var typ = this.options.get('taggableTypeToIncludeInAutocompleteQuery');
		element.setAttribute('data-taggable-type', typ);

		this.data = [];
		this.newOptionCount = 0;
		this.autoholder = $(autoholder).setOpacity(this.loptions.get('autocomplete').opacity);
		this.autoholder.observe('mouseover',function() {this.curOn = true;}.bind(this)).observe('mouseout',function() {this.curOn = false;}.bind(this));
		this.autoresults = this.autoholder.select('ul').first();
		if (this.autoresults) {
		var children = this.autoresults.select('li');
		children.each(function(el) { this.add({value:el.readAttribute('value'),caption:el.innerHTML}); }, this);
		}
		// Necessary workaround because initializing a second tag cloud overwrites the options of the first
		element.setAttribute('data-allowCreationOfNewOptions', this.options.get('allowCreationOfNewOptions') ? 1 : 0);
		// fetch and feed
		// var typ = this.options.get('taggableTypeToIncludeInAutocompleteQuery');
		if(options.tags && options.tags.length)
			options.tags.each(function(tag){ this.autoFeed(tag); }.bind(this));
		// else {  // Replaced with input.observe('click', in the createInput:
		// 	new Ajax.Request('tags/' + typ, {
		// 		method: 'get',
		// 		onSuccess: function(transport) {
		// 			transport.responseText.evalJSON(true).each(function(tag){
		// 				this.autoFeed(tag);
		// 			}.bind(this));
		// 		}.bind(this)
		// 	});
		// }

		this.cloud = this.element.up().next('.cloud');
		if(this.cloud){
			this.cloud.select('span').each(function(span){
				span.observe('click', function(){
					this.addFromExternal(span.readAttribute('rel').evalJSON(true));
				}.bind(this));
			}.bind(this));
		}
		this.loaded = true;
	},

	autoShow: function(search) {
		this.autoholder.setStyle({'display': 'block'});
		this.autoholder.descendants().each(function(e) { e.hide() });
		if(! search || ! search.strip() || (! search.length || search.length < this.loptions.get('autocomplete').minchars))
		{
			//commenting this next line out makes it so that there is not default text
			//(ie: Type the name of a tag.  To use an existing tag select it and press enter, separate new tags with a comma (,))
			//shown below the textbox.  I did this because it was getting in the way of people adding things from the tagcloud below it.
			//this.autoholder.select('.default').first().setStyle({'display': 'block'});
			this.resultsshown = false;
		} else {
			search = (search.strip()).replace(new RegExp('([^a-z0-9])','ig'),"\\$1");
			this.resultsshown = true;
			this.autoresults.setStyle({'display': 'block'}).update('');
			if (this.options.get('wordMatch'))
				var regexp = new RegExp("(^|\\s)"+search,'i')
			else
				var regexp = new RegExp(search,'i')
			var count = 0;
			var current_tag_input_parent_element = this.current.parentElement.parentElement;
			var current_tag_input = current_tag_input_parent_element.querySelector('#tags');
			var current_tag_input_value =
				current_tag_input && !!current_tag_input.value ? JSON.parse(current_tag_input.value) : [];

			this.data.filter(
				function (str) {
					var json_parsed_string = JSON.parse(str);
					return str ?
						regexp.test(str.evalJSON(true).caption) &&
						!current_tag_input_value.some(item => item.caption === json_parsed_string.caption)
						: false;
				}
			)
				.each(function(result, ti) {
				count++;
				if(ti >= this.loptions.get('autocomplete').maxresults) return;
				var that = this;
				var el = new Element('li');
				el.observe('click',function(e) {
					e.stop();
					that.autoAdd(this);
				}).observe('mouseover',function() {
					that.autoFocus(this);
				}).update(this.autoHighlight(result.evalJSON(true).caption, search));
				this.autoresults.insert(el);
				el.cacheData('result', result.evalJSON(true));
				if(ti == 0) this.autoFocus(el);
			}, this);
		}
		if(count === 0) {
			this.autoholder.select('.no_results_match').first().setStyle({'display': 'block'});
			this.autoresults.setStyle({'display': ''});
			this.resultsshown = false;
		} else {
			if (count > this.options.get('results'))
				this.autoresults.setStyle({'height': (this.options.get('results')*24)+'px'});
			else
				this.autoresults.setStyle({'height': (count?(count*24):0)+'px'});
			return this;
		}
	},

	autoHighlight: function(html, highlight) {
		return html.gsub(new RegExp(highlight,'i'), function(match) {
			return '<em>' + match[0] + '</em>';
		});
	},

	autoHide: function() {
		this.resultsshown = false;
		this.autoholder.hide();
		return this;
	},

	autoFocus: function(el) {
		if(! el) return;
		if(this.autocurrent) this.autocurrent.removeClassName('auto-focus');
		this.autocurrent = el.addClassName('auto-focus');
		return this;
	},

	autoMove: function(direction) {
		if(!this.resultsshown) return;
		this.autoFocus(this.autocurrent[(direction == 'up' ? 'previous' : 'next')]());
		this.autoresults.scrollTop = this.autocurrent.positionedOffset()[1]-this.autocurrent.getHeight();
		return this;
	},

	autoFeed: function(text) {
		if (this.data.indexOf(Object.toJSON(text)) == -1){
			var textAlreadyExistsInBits = this.bits.any(function(bit){
				return $(bit.key).retrieveData('text').evalJSON(true).value == text.value;
			});

			//do a check to make sure that it isnt a new tag that we have created,
			//so we dont add new tags back into the autocomplete options
			if( !text.value.toString().startsWith('new_') && textAlreadyExistsInBits === false){
				this.data.push(Object.toJSON(text));
			}
		}
		return this;
	},

	autoAdd: function(el) {
		if(!el || ! el.retrieveData('result')) return;
		const isTagSomethingDialog = !!this.element.closest('form')?.querySelector('#is_tag_something_dialog');
		const tag_custom_event = new CustomEvent("tag_added", {
			detail: {
				current_tag_name: el.retrieveData('result').caption,
				tag: el.retrieveData('result'),
				current_element: this.element,
				isTagSomethingDialog: isTagSomethingDialog,
			}
		});
		toggle_tag_from_cloud_element('added', el.retrieveData('result').caption, el.retrieveData('result').value, this);
		document.dispatchEvent(tag_custom_event);
		clearTimeout(this.blur_delay);
		this.add(el.retrieveData('result'));
		delete this.data[this.data.indexOf(Object.toJSON(el.retrieveData('result')))];
		this.autoHide();
		if(this.lastinput || this.current){
			var input = this.lastinput || this.current.retrieveData('input');
			input.clear().focus();
		}
		return this;
	},

	createNewOption: function(caption){
		this.newOptionCount += 1;
		var el = new Element('li')
			el.cacheData('result', {"caption": caption,"value": 'new_'+this.newOptionCount});
		this.autoAdd(el);
	},

	addFromExternal: function(result){
		var el = new Element('li')
			el.cacheData('result', {"caption": result.caption,"value": result.value});
		this.autoAdd(el);
		this.autoHide();
	},

	createInput: function($super,options) {
		var li = $super(options);
		var input = li.retrieveData('input');

		input.observe('click', function(e) {
			if (!input.classList.contains('loaded')) {
				var typ = this.element.getAttribute('data-taggable-type');

				show_loading_svg();
				new Ajax.Request('tags/' + typ, {
					method: 'get',
					onSuccess: function(transport) {
						var tags = transport.responseText.evalJSON(true);
						// Directly update instance data
						this.data = tags.map(tag => Object.toJSON(tag));
						// Feed to current instance
						tags.each(function(tag){
							this.autoFeed(tag);
						}.bind(this));
						this.autoShow(input.value);

						input.classList.add('loaded');
					}.bind(this),
					onComplete: function() {
						hide_loading_svg();
					}
				});
			}
		}.bind(this));

		input.observe('keydown', function(e) {
			if (!input.classList.contains('loaded')) {
				var typ = this.element.getAttribute('data-taggable-type');

				show_loading_svg();
				new Ajax.Request('tags/' + typ, {
					method: 'get',
					onSuccess: function(transport) {
						var tags = transport.responseText.evalJSON(true);
						// Directly update instance data
						this.data = tags.map(tag => Object.toJSON(tag));
						// Feed to current instance
						tags.each(function(tag){
							this.autoFeed(tag);
						}.bind(this));
						this.autoShow(input.value);

						input.classList.add('loaded');
					}.bind(this),
					onComplete: function() {
						hide_loading_svg();
					}
				});
			}

			this.dosearch = false;
			switch(e.keyCode) {
				case Event.KEY_UP: e.stop(); return this.autoMove('up');
				case Event.KEY_DOWN: e.stop(); return this.autoMove('down');
				case 188:
					e.stop();
					//if(this.options.get('allowCreationOfNewOptions')) // not reliable with multiple tag clouds
					if(this.element.getAttribute('data-allowCreationOfNewOptions') == 1)
					{
						input.value = input.value.strip();
						var alreadyExistsInBits = false;
						this.bits.each(function(pair){ //dont allow the creation of a new bit with the same caption as an existing bit.
							if (input.value.toUpperCase() == $(pair.key).retrieveData('text').evalJSON(true).caption.toUpperCase()){
								alreadyExistsInBits = true;
							}
						});
						if (alreadyExistsInBits || input.value.length == 0) break;
						this.createNewOption(input.value);
						this.autocurrent = false;
						this.autoenter = true;
						break;
					}
					break;
				case Event.KEY_RETURN:
					e.stop();
					if(! this.autocurrent) break;
					if(this.autocurrent.retrieveData('result').caption.toUpperCase().include(input.value.toUpperCase() ) ){
						this.autoAdd(this.autocurrent);
					}
					this.autocurrent = false;
					this.autoenter = true;
					break;
				case Event.KEY_ESC:
					this.autoHide();
					if(this.current && this.current.retrieveData('input'))
						this.current.retrieveData('input').clear();
					break;
				default: this.dosearch = true;
			}
		}.bind(this));
		input.observe('keyup',function(e) {
			switch(e.keyCode) {
				case Event.KEY_UP:
				case Event.KEY_DOWN:
				case Event.KEY_RETURN:
				case Event.KEY_ESC:
					break;
				default:
				if (!Object.isUndefined(this.options.get('fetchFile'))) {
					new Ajax.Request(this.options.get('fetchFile'), {
						parameters: {keyword: input.value},
						onSuccess: function(transport) {
							transport.responseText.evalJSON(true).each(function(t){this.autoFeed(t)}.bind(this));
							this.autoShow(input.value);
						}.bind(this)
					});
				}
				else
					if(this.dosearch) this.autoShow(input.value);
			}
		}.bind(this));
		input.observe(Prototype.Browser.IE ? 'keydown' : 'keypress', function(e) {
			if(this.autoenter) e.stop();
			this.autoenter = false;
		}.bind(this));
		return li;
	},

	createBox: function($super,text, options) {
		var li = $super(text, options);
		li.observe('mouseover',function() {
			this.addClassName('bit-hover');
		}).observe('mouseout',function() {
			this.removeClassName('bit-hover')
		});
		var a = new Element('a', {
			'href': 'javascript:void(0);',
			'class': 'closebutton'
		});
		a.observe('click',function(e) {	
			changetagdisplay(text['caption'], 'block');
			e.stop();
			toggle_tag_from_cloud_element('removed', li.innerText, text.value, this)
			const isTagSomethingDialog = !!this.element.closest('form')?.querySelector('#is_tag_something_dialog');
			const customEvent = new CustomEvent('tag_removed', {
				detail: {
					current_tag_name: li.innerText,
					current_element: this.element,
					tag: text,
					isTagSomethingDialog: isTagSomethingDialog,
				}
			});
			document.dispatchEvent(customEvent);

			if(! this.current) this.focus(this.maininput);
				this.dispose(li);
		}.bind(this));
		li.insert(a).cacheData('text', Object.toJSON(text));
		return li;
	}
});

Element.addMethods({
	onBoxDispose: function(item,obj) {
		var disposedTag = item.retrieveData('text').evalJSON(true);
		obj.autoFeed(disposedTag);
		if (disposedTag && disposedTag.caption) {
			if (typeof changetagdisplay === 'function')
				changetagdisplay(disposedTag.caption, 'block');
			if (typeof toggle_tag_from_cloud_element === 'function')
				toggle_tag_from_cloud_element('removed', disposedTag.caption, disposedTag.value, obj);
		}
	},
	onInputFocus: function(el,obj) { obj.autoShow(); },
	onInputBlur: function(el,obj) {
		//obj.lastinput = el;
		el.clear();	
		if(!obj.curOn) {
			obj.blurhide = obj.autoHide.bind(obj).delay(0.1);
		}
	},
	filter:function(D,E){var C=[];for(var B=0,A=this.length;B<A;B++){if(D.call(E,this[B],B,this)){C.push(this[B]);}}return C;}
});


function remove_data_from_multi_select(tag_id){
	if(tagsMultiSelect.data){
		tagsMultiSelect.data.each((o,i) => {
			var parsed = JSON.parse(o);
			if(parsed.value == tag_id)
				tagsMultiSelect.data[i] = "{\"caption\":\"\",\"value\":\"\"}";
		})
	}

	if(tagsMultiSelect.bits){
		var bits = tagsMultiSelect.bits;
		if(Object.keys(bits._object).length === 0) return;

		for (let key in bits._object) {
			if (bits._object.hasOwnProperty(key)) {
				let value = bits._object[key];
				if(value == tag_id){
					document.getElementById(key).remove();
					delete bits._object[key];
				}
			}
		}
	}
}

function toggle_tag_from_cloud_element (action, tag_name, tag_id, this_instance) {
	try {
		if (am.$('.tag_search_and_cloud').length < 0) {
			return;
		}

		const own_cloud = this_instance && this_instance.cloud ? this_instance.cloud : null;
		const cloud_element = own_cloud || am.$('.tag_search_and_cloud')[0].querySelector('.cloud');
		if (action === 'added' &&  cloud_element.querySelector('#' + tag_name)) {
			cloud_element.querySelector('#' + tag_name).remove();
		}

		if (action === 'removed' && !cloud_element.querySelector('#' + tag_name)) {
			let local_tag_clouds = [];
			try {
				local_tag_clouds = JSON.parse(localStorage.getItem('tag_cloud')) || [];
			} catch (e) {
				local_tag_clouds = [];
			}
			if (!Array.isArray(local_tag_clouds)) local_tag_clouds = [];
			const filter_local_tag_clouds = local_tag_clouds.filter((single_tag) => single_tag.name === tag_name);

			let newLi = document.createElement("li");
			newLi.id = tag_name;
			let newSpan = document.createElement("span");
			newSpan.setAttribute("onclick", "changetagdisplay(this, 'none');");
			if (filter_local_tag_clouds.length > 0) {
				const removed_local_tag = filter_local_tag_clouds[0];
				newLi.className = "size" + removed_local_tag.qty;
				newSpan.setAttribute("title", tag_name + ' (' + removed_local_tag.qty + ')');
			} else {
				newLi.className = "size";
				newSpan.setAttribute("title", tag_name);
			}
			newSpan.setAttribute("rel", JSON.stringify({ caption:tag_name, value: tag_id }));
			newSpan.textContent = tag_name;
			newLi.appendChild(newSpan);
			cloud_element.querySelector('div').appendChild(newLi);
			newSpan.addEventListener(
				"click",
				() => this_instance.addFromExternal(newSpan.readAttribute('rel').evalJSON(true))
			)
		}
	} catch(error) {
		console.log('', error)
	}
}
